import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  iconContainer: {
    display: "flex",
  },
  icon: {
    display: "flex",
    width: "45px",
    // backgroundColor:"red",
  },
}));

export default useStyles;
